import React from 'react';

import { Button } from './button.style';

function ButtonComponent(props) {
  return (
    <div>
      <Button className='af-general-button' {...props}>
        {props.children ? props.children : 'send'}
      </Button>
    </div>
  );
}

export default ButtonComponent;
